import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "member" }
const _hoisted_2 = { class: "with-tooltip" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "tooltip" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "stat-value"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "member-img",
      onDblclick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.characterOnDblclick && _ctx.characterOnDblclick(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: _normalizeClass('character' + _ctx.characterImgClass),
          src: _ctx.characterImgSrc,
          alt: _ctx.displayName(_ctx.member.name)
        }, null, 10, _hoisted_3),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.displayName(_ctx.member.name)), 1)
      ]),
      _createElementVNode("img", {
        class: "vision",
        src: _ctx.visionImgSrc,
        alt: "vision"
      }, null, 8, _hoisted_5),
      _withDirectives(_createElementVNode("div", { class: "constellation" }, _toDisplayString(_ctx.constellation), 513), [
        [_vShow, _ctx.constellation]
      ]),
      (_ctx.member.tags[3])
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass('tag tag-3' + _ctx.tagColorClass(3))
          }, _toDisplayString(_ctx.member.tags[3]), 3))
        : _createCommentVNode("", true),
      (_ctx.member.tags[2])
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass('tag tag-2' + _ctx.tagColorClass(2))
          }, _toDisplayString(_ctx.member.tags[2]), 3))
        : _createCommentVNode("", true),
      (_ctx.member.tags[1])
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass('tag tag-1' + _ctx.tagColorClass(1))
          }, _toDisplayString(_ctx.member.tags[1]), 3))
        : _createCommentVNode("", true),
      (_ctx.member.tags[0])
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass('tag tag-0' + _ctx.tagColorClass(0))
          }, _toDisplayString(_ctx.member.tags[0]), 3))
        : _createCommentVNode("", true),
      (_ctx.member.replacements[0])
        ? (_openBlock(), _createElementBlock("img", {
            key: 4,
            class: "replacement replacement-0",
            src: _ctx.replaceImgSrc(0),
            alt: _ctx.member.replacements[0]
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.member.replacements[1])
        ? (_openBlock(), _createElementBlock("img", {
            key: 5,
            class: "replacement replacement-1",
            src: _ctx.replaceImgSrc(1),
            alt: _ctx.member.replacements[1]
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ], 32),
    (_ctx.displayStat)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.statValue), 1))
      : _createCommentVNode("", true),
    (_ctx.showEquipment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("img", {
            class: "weapon",
            src: _ctx.imgWeaponSrc,
            alt: "weapon"
          }, null, 8, _hoisted_10),
          _createElementVNode("img", {
            class: "artifact-set",
            src: _ctx.imgArtifactSetSrc(0),
            alt: "artifact-set"
          }, null, 8, _hoisted_11),
          _createElementVNode("img", {
            class: "artifact-set",
            src: _ctx.imgArtifactSetSrc(1),
            alt: "artifact-set"
          }, null, 8, _hoisted_12)
        ]))
      : _createCommentVNode("", true)
  ]))
}